<template>
  <div class="form-check form-switch">
    <input
      :id="id"
      class="form-check-input"
      :class="$attrs.class"
      type="checkbox"
      :name="name"
      :checked="currentValue"
      @change="$emit('update:modelValue', $event.target.checked)"
    />
    <label class="form-check-label" :class="labelClass" :for="id">
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  name: "SoftSwitch",
  emits: ['update:modelValue'],
  props: {
    name: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    modelValue: {
      type: Boolean,
      default: false,
    },
    // Mantener checked para compatibilidad hacia atrás
    checked: {
      type: Boolean,
      default: false,
    },
    labelClass: {
      type: String,
      default: "",
    },
  },
  computed: {
    // Si no se pasa modelValue, usar checked
    currentValue() {
      return this.modelValue !== undefined ? this.modelValue : this.checked;
    }
  }
};
</script>
